import React from 'react';
import { CompassIcon, ScaleIcon, ShieldIcon, UsersIcon } from 'lucide-react';
import { whyPoints } from '../../data/homeContent';
import { Reveal } from '../ui/Reveal';
import { StarDivider } from '../ui/StarDivider';
const icons = [ShieldIcon, ScaleIcon, UsersIcon, CompassIcon];
export function WhyHpp() {
  return <section className="gutter section bg-ink" aria-labelledby="why-title" data-id="element-297" data-mp="1te5oe2d2i6jd">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-298" data-mp="28325eox3qtw4">
        <div className="lg:col-span-6" data-id="element-299" data-mp="285odqqrthdfe">
          <StarDivider align="left" data-id="element-300" data-mp="235jsyojvlwjd" />
          <h2 id="why-title" className="t-display mt-6 text-[clamp(2.4rem,4.8vw,6rem)] text-white" data-id="element-301" data-mp="234ij2neljg38">
            Shooting a gun and defending your life are two different skills.
          </h2>
          <span className="red-rule mt-7" aria-hidden="true" data-id="element-302" data-mp="2d3g61lwdj1k4" />
          <figure className="mt-8 max-w-[38rem]" data-id="element-303" data-mp="mpqoq4xw3yra">
            <blockquote className="t-lead text-chrome-100" data-id="element-304" data-mp="msl9xyoq9nlr">
              “There is a big difference in learning how to shoot a gun vs. learning how to use a gun for self-defense.”
            </blockquote>
            <figcaption className="mt-3 text-sm text-chrome-300" data-id="element-305" data-mp="2k9q10fwr81ye">— Maggie Mordaunt, Founder</figcaption>
          </figure>
        </div>
        <ul className="grid content-center gap-x-10 sm:grid-cols-2 lg:col-span-6" data-id="element-306" data-mp="2u98j0qt3tdnt">
          {whyPoints.map((p, i) => {
          const Icon = icons[i];
          return <li key={p.title} className="border-t border-white/15 py-7" data-id="element-307" data-mp="33zjx366i538f" data-mpi={i}>
                <Reveal delay={i * 0.05} data-id="element-308" data-mp="341mmpp3qsucm">
                  <Icon className="h-7 w-7 text-chrome-300" aria-hidden="true" data-id="element-309" data-mp="380dnq7bbww50" />
                  <h3 className="t-h3 mt-4 text-white" data-id="element-310" data-mp="3d0huh5mfqci1">{p.title}</h3>
                  <p className="mt-2 leading-relaxed text-chrome-300" data-id="element-311" data-mp="3cy5dovsey86k">{p.body}</p>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}